import { useState, useEffect } from "react";
import RoomScene from "../RoomScene/RoomScene";
import styles from './RoomSceneList.module.css';

// Generate a list of roomscenes
export default function RoomSceneList({ seriesId, thumbnailSize, onSceneSelect, filterCategory = 'All', roomScenes = [] }) {
    const [sceneData, setSceneData] = useState([]);

    // Use provided roomScenes or fetch them
    useEffect(() => {
        if (roomScenes && roomScenes.length > 0) {
            setSceneData(roomScenes);
        } else {
            const URL = `https://lizard.chameleonpower.com/CDN/RoomScenes/${seriesId}.json`;
            fetch(URL)
                .then((response) => response.json())
                .then((data) => setSceneData(data));
        }
    }, [seriesId, roomScenes]);

    // Handles roomscene select event
    const handleRoomsceneSelect = function (specifier) {
        // If custom onSceneSelect callback is provided, use it
        if (onSceneSelect) {
            onSceneSelect(specifier);
        }
    }

    // Filter scenes based on selected category
    const filteredScenes = filterCategory === 'All'
        ? sceneData
        : sceneData.filter(scene => {
            if (!scene.descriptor) return false;
            return scene.descriptor.trim() === filterCategory;
        });

    // Sort filtered scenes by description attribute
    const sortedScenes = [...filteredScenes].sort((a, b) => {
        const descA = (a.descriptor || '').toLowerCase();
        const descB = (b.descriptor || '').toLowerCase();
        return descA.localeCompare(descB);
    });

    // Generates an array of RoomScene template items
    let rsItems = sortedScenes.map(scene => <RoomScene
        key={scene.productId}
        specifier={scene.specifier}
        thumbnailSize={thumbnailSize}
        onSelect={handleRoomsceneSelect}
        isActive={false}
    />)

    let uploadSpecs = "";
    var uploadImages = localStorage.getItem("UPLOAD_SPECS");

    if (uploadImages !== null && filterCategory === 'All') {
        uploadSpecs = <RoomScene
            key={0}
            specifier={uploadImages}
            thumbnailSize={thumbnailSize}
            onSelect={handleRoomsceneSelect}
            isActive={false}
        />
    }

    return (
        <div className={styles.roomsceneListContainer}>
            <ol className={styles.roomsceneList}>
                {uploadSpecs}
                {rsItems}
            </ol>
        </div>
    )
}